// Per-session (in-memory only) Power BI report state. Cleared on page reload or logout.
const parsedMax = parseInt(process.env.REACT_APP_PBI_SESSION_STATE_MAX_REPORTS, 10);
const MAX_ENTRIES = Number.isFinite(parsedMax) && parsedMax >= 0 ? parsedMax : 50;

const entries = new Map();
let navStartedAt = null;

export function getReportSessionState(reportId) {
  if (!reportId) return undefined;
  return entries.get(reportId);
}

export function saveReportSessionState(reportId, patch) {
  if (!reportId || MAX_ENTRIES === 0) return;
  const next = { ...entries.get(reportId), ...patch, updatedAt: Date.now() };
  // Re-insert so Map iteration order stays least-recently-updated first.
  entries.delete(reportId);
  entries.set(reportId, next);
  while (entries.size > MAX_ENTRIES) {
    entries.delete(entries.keys().next().value);
  }
}

export function clearAllReportSessionState() {
  entries.clear();
  navStartedAt = null;
}

export function markReportNavStart() {
  navStartedAt = performance.now();
}

export function consumeReportNavStart() {
  if (navStartedAt === null) return null;
  const elapsed = performance.now() - navStartedAt;
  navStartedAt = null;
  return elapsed;
}
